interface DisplayGiftCardPhoneNumberProps {
  phone: string;
}

const DisplayGiftCardPhoneNumber = (props: DisplayGiftCardPhoneNumberProps) => {
  const { phone } = props;

  return (
    <div className="text-sm text-grey-dark">
      <span>{phone}</span>
    </div>
  );
};

export default DisplayGiftCardPhoneNumber;
